export interface PatchData {
  id: string;
  taskId: string;
  timestamp: Date;
  description: string;
  changes: string;
}

export interface RevertRequest {
  taskId: string;
  patchId: string;
}

export interface RevertResponse {
  success: boolean;
  message: string;
  patchId?: string;
}

export async function revertPatch(taskId: string, patchId: string): Promise<RevertResponse> {
  try {
    const baseUrl = import.meta.env.VITE_ARCOS_API_URL || 'http://localhost:8000';
    const apiKey = import.meta.env.VITE_ARCOS_API_KEY || 'dev-key';

    const response = await fetch(`${baseUrl}/api/bees/revertBee/run`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`
      },
      body: JSON.stringify({ taskId, patchId })
    });

    if (!response.ok) {
      throw new Error(`RevertBee API error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('RevertBee API error:', error);
    return {
      success: false,
      message: 'Failed to revert patch. Please try again.'
    };
  }
}

export async function fetchPatches(sessionId: string): Promise<PatchData[]> {
  try {
    const baseUrl = import.meta.env.VITE_ARCOS_API_URL || 'http://localhost:8000';
    const apiKey = import.meta.env.VITE_ARCOS_API_KEY || 'dev-key';

    const response = await fetch(`${baseUrl}/api/audit/patches?scope=${sessionId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${apiKey}`
      }
    });

    if (!response.ok) {
      throw new Error(`Audit API error: ${response.status}`);
    }

    const data = await response.json();
    return data.map((patch: { id: string; taskId: string; timestamp: string; description: string; changes: string }) => ({
      ...patch,
      timestamp: new Date(patch.timestamp)
    }));
  } catch (error) {
    console.error('Audit API error:', error);
    return [
      {
        id: 'patch-demo-1',
        taskId: 'demo-task',
        timestamp: new Date(Date.now() - 3600000),
        description: 'Updated component styling',
        changes: 'Modified CSS classes and layout'
      },
      {
        id: 'patch-demo-2', 
        taskId: 'demo-task',
        timestamp: new Date(Date.now() - 7200000),
        description: 'Fixed API integration',
        changes: 'Updated API endpoint calls'
      }
    ];
  }
}
